import { PLAN_TYPE } from "../../../types";

export default class User {
  firstName: string;
  lastName: string;
  username: string;
  password: string;
  email: string | null;
  avatar: string | null;
  id: string;
  identityId: string;
  plan: PLAN_TYPE;
  seats: number;
  credits: number;
  bought_credits: number;
  subscription_id: string;
  subscription_status: string;
  customization: string;
  access_purchased: boolean;
  status: { name: string };

  constructor(data: any) {
    const user = {
      ...data,
      firstName: data.first_name,
      lastName: data.last_name,
    }
    Object.assign(this, user);
  }
}
